import { Route, Navigate, Outlet } from 'react-router-dom';
import { type RouteRegistryEntry } from 'FrontRoyalRouteRegistry/FrontRoyalRouteRegistry.types';
import { ProtectedRoute } from 'ProtectedRoute';
import { BrowseCourses } from './BrowseCourses';
import { BROWSE_COURSES_ROUTES } from './routes';

// Re-export routes for backwards compatibility
export { BROWSE_COURSES_ROUTES } from './routes';

export function configureBrowseCoursesRoutes(): RouteRegistryEntry[] {
    return [
        {
            routes: BROWSE_COURSES_ROUTES,
            config: {},
        },
    ];
}

export function getBrowseCoursesRoutes() {
    return (
        <Route id="browse-courses-routes" element={<Outlet />}>
            <Route path={BROWSE_COURSES_ROUTES.LIBRARY.path} element={<Navigate to="/courses" replace />} />
            <Route
                path={BROWSE_COURSES_ROUTES.COURSES.path}
                element={
                    <ProtectedRoute accessPolicy="unrestricted">
                        <BrowseCourses />
                    </ProtectedRoute>
                }
            />
        </Route>
    );
}
